import React, { createContext, useContext, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};

const initialPrisons = [
  {
    id: 'hmp-belmarsh',
    name: 'HMP Belmarsh',
    location: 'London',
    capacity: 910,
    type: 'Category A',
    manager: 'Sarah Johnson'
  },
  {
    id: 'hmp-pentonville',
    name: 'HMP Pentonville',
    location: 'London',
    capacity: 1274,
    type: 'Category B',
    manager: 'Michael Thompson'
  },
  {
    id: 'hmp-wandsworth',
    name: 'HMP Wandsworth',
    location: 'London',
    capacity: 1665,
    type: 'Category B',
    manager: 'Emma Davis'
  }
];

const initialInventory = {
  'hmp-belmarsh': [
    { id: 'sand-001', name: 'Chicken & Salad Sandwich', category: 'Sandwiches', price: 3.50, stock: 25, image: 'https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=300&h=200&fit=crop' },
    { id: 'sand-002', name: 'Ham & Cheese Sandwich', category: 'Sandwiches', price: 3.25, stock: 30, image: 'https://images.unsplash.com/photo-1567234669013-c6c13b5c1c8a?w=300&h=200&fit=crop' },
    { id: 'sand-003', name: 'Tuna Mayo Sandwich', category: 'Sandwiches', price: 3.00, stock: 20, image: 'https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=300&h=200&fit=crop' },
    { id: 'drink-001', name: 'Tea', category: 'Hot Drinks', price: 1.50, stock: 50, image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=300&h=200&fit=crop' },
    { id: 'drink-002', name: 'Coffee', category: 'Hot Drinks', price: 1.75, stock: 45, image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=300&h=200&fit=crop' },
    { id: 'drink-003', name: 'Hot Chocolate', category: 'Hot Drinks', price: 2.00, stock: 30, image: 'https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed?w=300&h=200&fit=crop' },
    { id: 'cold-001', name: 'Coca Cola', category: 'Cold Drinks', price: 1.80, stock: 40, image: 'https://images.unsplash.com/photo-1581636625402-29b2a704ef13?w=300&h=200&fit=crop' },
    { id: 'cold-002', name: 'Orange Juice', category: 'Cold Drinks', price: 2.25, stock: 35, image: 'https://images.unsplash.com/photo-1621506289937-a8e4df240d0b?w=300&h=200&fit=crop' },
    { id: 'snack-001', name: 'Chocolate Bar', category: 'Snacks', price: 1.25, stock: 60, image: 'https://images.unsplash.com/photo-1606312619070-d48b4c652a52?w=300&h=200&fit=crop' },
    { id: 'snack-002', name: 'Crisps', category: 'Snacks', price: 1.00, stock: 80, image: 'https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=300&h=200&fit=crop' }
  ],
  'hmp-pentonville': [
    { id: 'sand-001', name: 'Chicken & Salad Sandwich', category: 'Sandwiches', price: 3.50, stock: 20, image: 'https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=300&h=200&fit=crop' },
    { id: 'sand-002', name: 'Ham & Cheese Sandwich', category: 'Sandwiches', price: 3.25, stock: 25, image: 'https://images.unsplash.com/photo-1567234669013-c6c13b5c1c8a?w=300&h=200&fit=crop' },
    { id: 'drink-001', name: 'Tea', category: 'Hot Drinks', price: 1.50, stock: 40, image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=300&h=200&fit=crop' },
    { id: 'drink-002', name: 'Coffee', category: 'Hot Drinks', price: 1.75, stock: 35, image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=300&h=200&fit=crop' },
    { id: 'cold-001', name: 'Coca Cola', category: 'Cold Drinks', price: 1.80, stock: 30, image: 'https://images.unsplash.com/photo-1581636625402-29b2a704ef13?w=300&h=200&fit=crop' },
    { id: 'snack-001', name: 'Chocolate Bar', category: 'Snacks', price: 1.25, stock: 50, image: 'https://images.unsplash.com/photo-1606312619070-d48b4c652a52?w=300&h=200&fit=crop' }
  ],
  'hmp-wandsworth': [
    { id: 'sand-001', name: 'Chicken & Salad Sandwich', category: 'Sandwiches', price: 3.50, stock: 30, image: 'https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=300&h=200&fit=crop' },
    { id: 'sand-003', name: 'Tuna Mayo Sandwich', category: 'Sandwiches', price: 3.00, stock: 25, image: 'https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=300&h=200&fit=crop' },
    { id: 'drink-001', name: 'Tea', category: 'Hot Drinks', price: 1.50, stock: 60, image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=300&h=200&fit=crop' },
    { id: 'drink-002', name: 'Coffee', category: 'Hot Drinks', price: 1.75, stock: 55, image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=300&h=200&fit=crop' },
    { id: 'cold-002', name: 'Orange Juice', category: 'Cold Drinks', price: 2.25, stock: 40, image: 'https://images.unsplash.com/photo-1621506289937-a8e4df240d0b?w=300&h=200&fit=crop' },
    { id: 'snack-002', name: 'Crisps', category: 'Snacks', price: 1.00, stock: 70, image: 'https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=300&h=200&fit=crop' }
  ]
};

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [prisons, setPrisons] = useState(initialPrisons);
  const [inventory, setInventory] = useState(initialInventory);
  const [orders, setOrders] = useState([]);
  const [cart, setCart] = useState([]);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    setCart([]);
  };

  const addToCart = (item, prisonId) => {
    const cartItem = {
      ...item,
      cartId: uuidv4(),
      prisonId,
      quantity: 1
    };
    setCart(prev => [...prev, cartItem]);
  };

  const removeFromCart = (cartId) => {
    setCart(prev => prev.filter(item => item.cartId !== cartId));
  };

  const updateCartQuantity = (cartId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(cartId);
      return;
    }
    setCart(prev => prev.map(item => 
      item.cartId === cartId ? { ...item, quantity } : item
    ));
  };

  const clearCart = () => {
    setCart([]);
  };

  const createOrder = (orderData) => {
    const order = {
      id: uuidv4(),
      ...orderData,
      status: 'pending',
      createdAt: new Date().toISOString(),
      items: cart.map(item => ({
        ...item,
        total: item.price * item.quantity
      })),
      total: cart.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    };
    
    setOrders(prev => [...prev, order]);
    
    // Update inventory
    cart.forEach(cartItem => {
      setInventory(prev => ({
        ...prev,
        [cartItem.prisonId]: prev[cartItem.prisonId].map(invItem =>
          invItem.id === cartItem.id
            ? { ...invItem, stock: Math.max(0, invItem.stock - cartItem.quantity) }
            : invItem
        )
      }));
    });
    
    clearCart();
    return order;
  };

  const updateOrderStatus = (orderId, status) => {
    setOrders(prev => prev.map(order =>
      order.id === orderId ? { ...order, status } : order
    ));
  };

  const updateInventory = (prisonId, itemId, updates) => {
    setInventory(prev => ({
      ...prev,
      [prisonId]: prev[prisonId].map(item =>
        item.id === itemId ? { ...item, ...updates } : item
      )
    }));
  };

  const addInventoryItem = (prisonId, item) => {
    const newItem = {
      ...item,
      id: uuidv4()
    };
    setInventory(prev => ({
      ...prev,
      [prisonId]: [...(prev[prisonId] || []), newItem]
    }));
  };

  const deleteInventoryItem = (prisonId, itemId) => {
    setInventory(prev => ({
      ...prev,
      [prisonId]: prev[prisonId].filter(item => item.id !== itemId)
    }));
  };

  const value = {
    user,
    prisons,
    inventory,
    orders,
    cart,
    login,
    logout,
    addToCart,
    removeFromCart,
    updateCartQuantity,
    clearCart,
    createOrder,
    updateOrderStatus,
    updateInventory,
    addInventoryItem,
    deleteInventoryItem
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};